var _dec, _class;
/** @module components/MetaBox */

import React, { useState } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import { observer, inject } from "mobx-react";
import { Icon } from "react-aiot";
import { request, hooks, rmlOpts, i18n, getMediaDialogNextZIndex } from "../util";
import FolderBox, { FolderBoxHeader } from "./FolderBox";
import { Modal } from ".";
import { MediaLibrarySelector } from "./MediaLibrarySelector";
import { useEffect } from "react";

/**
 * Show a meta box for the selected folder id. It also supports
 * user settings.
 *
 * @property {string|int} id The id of the folder or 'usersettings'
 * @extends React.Component
 */
let MetaBox = (_dec = inject("store"), _dec(_class = observer(_class = class MetaBox extends React.Component {
  constructor(props) {
    super(props);
    this.handleRef = ref => {
      this.refSpan = ref;

      /**
       * The MetaBox ref element is ready and created.
       *
       * @event module:util/hooks#folder/meta
       * @param {HTMLElement} ref The reference
       * @param {string|id} id The folder id or 'usersettings'
       * @param {module:store~Store} store The store
       * @this MetaBox instance
       */
      hooks.call("folder/meta", [ref, this.state.id, this.props.store], this);
    };
    this.handleSave = async () => {
      const form = $(this.refSpan).children("form"),
        serialize = form.serializeArray(),
        data = {};
      $.each(serialize, (key, value) => data[value.name] = value.value);

      /**
       * The MetaBox is serialized and ready to send.
       *
       * @event module:util/hooks#folder/meta/serialize
       * @param {string|id} id The folder id or 'usersettings'
       * @param {module:store~Store} store The store
       * @param {object} data The data prepared for the server so you can perhaps modify it
       * @param {HTMLElement} form The form container
       * @this MetaBox instance
       */
      hooks.call("folder/meta/serialize", [this.state.id, this.props.store, data, form], this);
      try {
        const response = await request({
          location: {
            path: this.state.id === "usersettings" ? "/usersettings" : "/folders/" + this.state.id + "/meta",
            method: "PUT"
          },
          request: data
        });

        /**
         * The MetaBox is saved successfully.
         *
         * @event module:util/hooks#folder/meta/saved
         * @param {string|id} id The folder id or 'usersettings'
         * @param {object} response The server response
         * @param {object} data The data sent to the server
         * @this MetaBox instance
         */
        hooks.call("folder/meta/saved", [this.state.id, response, data], this);
        this.props.onClose(true, response);
      } catch ({
        responseJSON: {
          message
        }
      }) {
        this.setState({
          errors: message
        });
      } finally {
        this.setState({
          loading: false
        });
      }
    };
    this.state = {
      id: 0,
      // The current visible id
      html: "",
      // The html
      loading: false,
      errors: []
    };
  }
  componentDidUpdate() {
    const {
      id
    } = this.props;
    if (id !== this.state.id) {
      this.setState({
        id,
        html: ""
      });
      if (id !== false) {
        request({
          location: {
            path: id === "usersettings" ? "/usersettings" : "/folders/" + id + "/meta"
          }
        }).then(_ref => {
          let {
            html
          } = _ref;
          this.setState({
            html
          });
        }, () => {
          // An error occured
          this.setState({
            html: ""
          });
        });
      }
    }
  }
  render() {
    let selected, modalContent, title;
    if (this.props.id === "usersettings") {
      selected = {
        icon: /*#__PURE__*/React.createElement(Icon, {
          type: "setting"
        }),
        title: rmlOpts.others.lang.userSettingsToolTipTitle
      };
    } else {
      selected = this.props.store.getTreeItemById(this.props.id, false);
    }
    const {
      html,
      loading,
      errors
    } = this.state;
    if (selected) {
      title = /*#__PURE__*/React.createElement(FolderBoxHeader, {
        icon: /*#__PURE__*/React.createElement(Icon, {
          type: "ellipsis"
        }),
        folder: selected
      });
      modalContent = /*#__PURE__*/React.createElement(FolderBox, {
        busy: !html || loading,
        folder: selected,
        errors: errors,
        header: false
      }, html && /*#__PURE__*/React.createElement("div", {
        className: "inside"
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: html
        },
        style: {
          display: html ? "block" : "none"
        },
        ref: this.handleRef
      })));
    }
    return /*#__PURE__*/React.createElement(Modal, {
      visible: !!modalContent,
      title: title,
      onOk: this.handleSave,
      onCancel: this.props.onClose,
      cancelText: i18n("cancel"),
      okText: i18n("save"),
      zIndex: getMediaDialogNextZIndex(),
      confirmLoading: loading
    }, modalContent);
  }
}) || _class) || _class);
const CoverImageSelector = _ref2 => {
  let {
    input,
    modal
  } = _ref2;
  const [attachmentId, setAttachmentId] = useState(input.val());
  useEffect(() => {
    input.val(attachmentId);
  }, [attachmentId]);
  return /*#__PURE__*/React.createElement(MediaLibrarySelector, {
    attachmentId: attachmentId,
    onChange: id => setAttachmentId(id),
    title: "Select cover image",
    allowedTypes: ["image"],
    render: _ref3 => {
      let {
        open,
        reset,
        attachmentId,
        url
      } = _ref3;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        onClick: open
      }, attachmentId ? "Replace image" : "Select from media library"), "\xA0", attachmentId && /*#__PURE__*/React.createElement("a", {
        className: "button",
        onClick: reset
      }, "Remove image")), url && /*#__PURE__*/React.createElement("img", {
        style: {
          maxWidth: "100%",
          height: "auto"
        },
        src: url
      }));
    },
    ref: ref => {
      if (ref?.frame) {
        ref.frame.on("open", () => modal.hide()).on("close", () => modal.show());
      }
    }
  });
};

/**
 * Wait for the input field for the cover image and create a media picker.
 *
 * @see https://wordpress.stackexchange.com/questions/190987/how-do-i-create-a-custom-add-media-button-modal
 */
hooks.register("wprfc/metaCoverImage", function () {
  const input = $(this).hide();
  const modal = $(this).parents(".ant-modal-wrap").parent();
  ReactDOM.render( /*#__PURE__*/React.createElement(CoverImageSelector, {
    input: input,
    modal: modal
  }), $("<div />").css("margin-top", "5px").insertAfter($(this)).get(0));
});
export default MetaBox;